import axios from "axios";
import { ManagementUnit } from "../../types/model/managementUnit";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/management-units`;

export const listManagementUnits = async (
  writeAccessOnly?: boolean,
): Promise<ManagementUnit[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<ManagementUnit[]>(`${BASE_URL}`, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params: {
      writeAccessOnly,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
